import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
interface ClassTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  classType?: any;
}
export function ClassTypeModal({
  isOpen,
  onClose,
  onSave,
  classType
}: ClassTypeModalProps) {
  const [formData, setFormData] = useState({
    name: classType?.name || '',
    modality: classType?.modality || 'presencial',
    duration: classType?.duration || 60,
    price: classType?.price || 1,
    description: classType?.description || '',
    is_active: classType?.is_active ?? true
  });
  useEffect(() => {
    if (isOpen) {
      setFormData({
        name: classType?.name || '',
        modality: classType?.modality || 'presencial',
        duration: classType?.duration || 60,
        price: classType?.price || 1,
        description: classType?.description || '',
        is_active: classType?.is_active ?? true
      });
    }
  }, [isOpen, classType]);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-earth/50 backdrop-blur-sm" data-id="element-528">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} className="bg-white rounded-3xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]" data-id="element-529">
        <div className="p-6 border-b border-mist flex justify-between items-center bg-sand/30" data-id="element-530">
          <h2 className="font-display text-2xl font-bold text-earth" data-id="element-531">
            {classType ? 'Editar Tipo de Clase' : 'Nuevo Tipo de Clase'}
          </h2>
          <button onClick={onClose} className="text-stone hover:text-earth p-2 rounded-full hover:bg-white transition-colors" data-id="element-532">
            <X size={20} data-id="element-533" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1" data-id="element-534">
          <form id="classtype-form" onSubmit={handleSubmit} className="space-y-5" data-id="element-535">
            <div data-id="element-536">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-537">
                Nombre *
              </label>
              <input type="text" required value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-538" />
            </div>

            <div data-id="element-539">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-540">
                Modalidad
              </label>
              <select value={formData.modality} onChange={e => setFormData({
              ...formData,
              modality: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10 bg-white" data-id="element-541">
                <option value="presencial" data-id="element-542">Presencial</option>
                <option value="virtual" data-id="element-543">Virtual (Zoom)</option>
                <option value="privada" data-id="element-544">Privada</option>
                <option value="grupal" data-id="element-545">Grupal</option>
              </select>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-546">
              <div data-id="element-547">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-548">
                  Duración (min)
                </label>
                <input type="number" min="15" required value={formData.duration} onChange={e => setFormData({
                ...formData,
                duration: parseInt(e.target.value)
              })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-549" />
              </div>
              <div data-id="element-550">
                <label className="block text-sm font-semibold text-earth mb-2" data-id="element-551">
                  Precio (USD)
                </label>
                <input type="number" min="0" step="0.01" required value={formData.price} onChange={e => setFormData({
                ...formData,
                price: parseFloat(e.target.value)
              })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10" data-id="element-552" />
              </div>
            </div>

            <div data-id="element-553">
              <label className="block text-sm font-semibold text-earth mb-2" data-id="element-554">
                Descripción
              </label>
              <textarea rows={3} value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} className="w-full p-3 border-2 border-mist rounded-xl text-sm outline-none focus:border-sage focus:ring-4 focus:ring-sage/10 resize-none" data-id="element-555" />
            </div>

            <div className="flex items-center gap-3 pt-2" data-id="element-556">
              <input type="checkbox" id="is_active_ct" checked={formData.is_active} onChange={e => setFormData({
              ...formData,
              is_active: e.target.checked
            })} className="w-5 h-5 text-sage rounded border-mist focus:ring-sage" data-id="element-557" />
              <label htmlFor="is_active_ct" className="text-sm font-semibold text-earth" data-id="element-558">
                Tipo de clase activo
              </label>
            </div>
          </form>
        </div>

        <div className="p-6 border-t border-mist bg-sand/10 flex gap-3 justify-end" data-id="element-559">
          <button type="button" onClick={onClose} className="px-6 py-2.5 rounded-xl text-sm font-semibold text-stone hover:bg-mist/30 transition-colors" data-id="element-560">
            Cancelar
          </button>
          <button form="classtype-form" type="submit" className="px-6 py-2.5 rounded-xl text-sm font-semibold bg-sage text-white hover:bg-sage/90 transition-colors shadow-sm" data-id="element-561">
            Guardar
          </button>
        </div>
      </motion.div>
    </div>;
}